module.exports = __webpack_public_path__ + "img/tairoa.c258cf58.jpg";